import { useMemo } from 'react'
import { Button, HStack, VStack } from '@chakra-ui/react'
import NavBar from 'components/NavBar'
import { useSelector } from 'model/hooks'
import { NodeDataT } from 'shared/types'
import { AddIcon } from '@chakra-ui/icons'
import { dbCreateCoursesPack } from 'controllers/coursesPacks'
import { useNavigate } from 'react-router-dom'
import _ from 'lodash'
import { NodeModel } from '@minoru/react-dnd-treeview'
import FileThree from 'components/FileThree'
import { dbUpdateFileTree } from 'controllers/fileThree'

const CoursesPacks = () => {
  const navigate = useNavigate()
  const coursesPacks = useSelector(state => state.coursesPacks)

  const fileThreeDBData = useSelector(state => state.fileTree)

  const treeData = useMemo(() => {
    const dbTreeRaw = _.get(fileThreeDBData, 'tariffs', [])
    const dbTree = _.map(dbTreeRaw, el => {
      if (el.data && el.data.id) {
        const c = _.get(coursesPacks, el.data.id)
        if (c) {
          return { ...el, text: _.get(c, 'title', 'unnamed') }
        } else {
          return null
        }
      } else {
        return el
      }
    })
    const res = _.compact(dbTree)
    const dbTreeDict = _.keyBy(dbTree, 'id')
    _.forEach(coursesPacks, c => {
      if (!_.has(dbTreeDict, c.id)) {
        const n: NodeModel<NodeDataT> = {
          id: c.id,
          parent: 'root',
          text: c.title,
          droppable: false,
          data: {
            id: c.id
          }
        }
        res.push(n)
      }
    })
    return res
  }, [fileThreeDBData, coursesPacks])

  const onCreateCoursesPackClick = async () => {
    const packId = await dbCreateCoursesPack()
    navigate(`/tariffs/${packId}`)
  }

  const navBarActions = (
    <HStack>
      <Button
        colorScheme='teal'
        leftIcon={<AddIcon />}
        onClick={onCreateCoursesPackClick}
      >
        Создать тариф
      </Button>
    </HStack>
  )

  const onChangeFileTree = (treeData: NodeModel<NodeDataT>[]) => {
    dbUpdateFileTree('tariffs', treeData)
  }

  return (
    <VStack w='full' h='full' spacing={0}>
      <NavBar hideBackButton title='Тарифы'>
        {navBarActions}
      </NavBar>
      <VStack align={'center'} w='full' h='full' p={4} overflowY={'auto'}>
        <VStack maxW='4xl' w='full'>
          <FileThree
            treeData={treeData}
            onChange={onChangeFileTree}
            onNodeClick={id => navigate(`/tariffs/${id}`)}
          />
        </VStack>
      </VStack>
    </VStack>
  )
}

export default CoursesPacks
